namespace Matrix.Data {
    export interface SecurityRepairLogRow {
        RepairId?: number;
        SecMergeRowId?: number;
        FromSecurityId?: number;
        FromSecurityCode?: string;
        FromSecurityName?: string;
        ToSecurityId?: number;
        ToSecurityCode?: string;
        ToSecurityName?: string;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ProcessedWhen?: string;
        ProcessedBy?: string;
        StdOut?: string;
        StdErr?: string;
        StatusCode?: string;
        RowId?: number;
    }

    export namespace SecurityRepairLogRow {
        export const idProperty = 'RepairId';
        export const nameProperty = 'CreatedBy';
        export const localTextPrefix = 'Data.SecurityRepairLog';
        export const deletePermission = 'SecurityRepairLog:General';
        export const insertPermission = 'SecurityRepairLog:General';
        export const readPermission = 'SecurityRepairLog:General';
        export const updatePermission = 'SecurityRepairLog:General';

        export declare const enum Fields {
            RepairId = "RepairId",
            SecMergeRowId = "SecMergeRowId",
            FromSecurityId = "FromSecurityId",
            FromSecurityCode = "FromSecurityCode",
            FromSecurityName = "FromSecurityName",
            ToSecurityId = "ToSecurityId",
            ToSecurityCode = "ToSecurityCode",
            ToSecurityName = "ToSecurityName",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ProcessedWhen = "ProcessedWhen",
            ProcessedBy = "ProcessedBy",
            StdOut = "StdOut",
            StdErr = "StdErr",
            StatusCode = "StatusCode",
            RowId = "RowId"
        }
    }
}
